export class AlarmStage {
    static #_stage0 = {
        name: 'High',
        color: '#335c81',
        colorBorder: '#d23f1e',
        textColor: 'white',
    };
    static #_stage1 = {
        name: 'Medium',
        color: '#85a4c2',
        colorBorder: '#d23f1e',
        textColor: 'black',
    };
    static #_stage2 = {
        name: 'Low',
        color: '#cedae6',
        // color: "#a1b8cf",
        colorBorder: '#d23f1e',
        textColor: 'black',
    };
    static #_stage3 = {
        name: 'None',
        color: '#5f5c58',
        colorBorder: '#d23f1e',
        textColor: 'white',
    };

    static get High() {
        return this.#_stage0;
    }

    static get Medium() {
        return this.#_stage1;
    }

    static get Low() {
        return this.#_stage2;
    }

    static get None() {
        return this.#_stage3;
    }

    static AlarmStageName(stageColor) {
        if (stageColor === this.#_stage0.color) return this.#_stage0.name;
        if (stageColor === this.#_stage1.color) return this.#_stage1.name;
        if (stageColor === this.#_stage2.color) return this.#_stage2.name;
        if (stageColor === this.#_stage3.color) return this.#_stage3.name;
    }

    static AlarmStageBorder(stageColor) {
        if (stageColor === this.#_stage0.color) return this.#_stage0.colorBorder;
        if (stageColor === this.#_stage1.color) return this.#_stage1.colorBorder;
        if (stageColor === this.#_stage2.color) return this.#_stage2.colorBorder;
        if (stageColor === this.#_stage3.color) return this.#_stage3.colorBorder;
        return 'blue';
    }

    static AlarmStageTextColor(stageColor) {
        if (stageColor === this.#_stage0.color) return this.#_stage0.textColor;
        if (stageColor === this.#_stage1.color) return this.#_stage1.textColor;
        if (stageColor === this.#_stage2.color) return this.#_stage2.textColor;
        if (stageColor === this.#_stage3.color) return this.#_stage3.textColor;
        return 'black';
    }

    static AlarmStageP(stageColor) {
        if (stageColor === this.#_stage0.color) return 0;
        if (stageColor === this.#_stage1.color) return 1;
        if (stageColor === this.#_stage2.color) return 2;
        if (stageColor === this.#_stage3.color) return 3;
        return 4;
    }
}